import { DisciplineResults } from '../../Components/DisciplineResults';

export const CmpHighpowerResults = () => {
  return (
    <DisciplineResults 
      discipline="CMP_HIGHPOWER" 
      disciplineName="CMP Highpower/Service Rifle"
    />
  );
};
